import React from 'react';
import { connect } from "react-redux";
import '../styles/elements/preloader.scss';
import {WavingTriangle} from "./WavingTriangle";


export class Preloader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
    }

    getStyle() {
        return {
            display: this.props.preloader ? 'block' : 'none'
        }
    }

    render() {
        return (
            <div id="preloader" className="imd-bg-transparent-default" style={this.getStyle()}>
                <WavingTriangle size={200} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        preloader: state.preloader
    }
};

export const PreloaderContainer = connect(mapStateToProps, {})(Preloader);
